export enum JourneyPartType {
   AdditionalOptions = 'additional',
   Package = 'package',
   Path = 'path',
   Headline = 'headline',
   Root = 'root'
}
